import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/redhat': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M341.5 285.4v0.1c33.7 0 82.3-6.9 82.3-47 0.2-6.7 0.9-1.8-20.9-96.2-4.6-19.2-8.7-27.8-42.3-44.7-26.1-13.3-82.9-35.4-99.7-35.4-15.7 0-20.2 20.2-38.9 20.2-18 0-31.3-15.1-48.1-15.1-16.1 0-26.7 11-34.8 33.6-27.5 77.5-26.3 74.3-26.1 78.3 0 24.8 97.6 106.1 228.5 106.1zM429.1 254.8l-0.1 0c4.7 22 4.7 24.4 4.7 27.3 0 37.7-42.3 58.6-98 58.6-125.7 0.1-235.9-73.7-235.9-122.3v-0.1c0-5.7 1.8-14.5 4.1-19.6-45.2 2.3-103.8 10.3-103.8 62 0 84.7 200.6 189 359.5 189 121.8 0 152.5-55.1 152.5-98.6 0-34.2-29.6-73-82.9-96.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/redhat.js
// module id = 991
// module chunks = 0